
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["font-color",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.75 17.12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Vrstva_2","data-name":"Vrstva 2"}},[_c('g',{attrs:{"id":"Vrstva_1-2","data-name":"Vrstva 1"}},[_c('path',{attrs:{"d":"M6 3.92a10.72 10.72 0 00.1 8.3C3 10.41 1.25 7.8 1 6.4a7.24 7.24 0 00-1 3.81A7.31 7.31 0 001 14a7.23 7.23 0 002.82 2.66 10 10 0 00.94.43 3 3 0 01-.17-3.42 6.17 6.17 0 003.27 2.22V1.3A8.66 8.66 0 006 3.92z"}}),_c('path',{attrs:{"d":"M3.27 5.85a1.42 1.42 0 001.26-1.19A4.57 4.57 0 002.83.88c.4 2.25-1 2.86-.89 3.93a1.2 1.2 0 001.33 1.04z"}}),_c('path',{attrs:{"d":"M11.46 9.42c2.4 3.52 1.53 5.68.86 7a7.12 7.12 0 003.43-6.22s.09-2.42-3.23-4.65a7.64 7.64 0 01-2.21-2.45A6.77 6.77 0 019.47 0a11.87 11.87 0 00-1.59 1.3v14.62a3.13 3.13 0 00.41.09 8.14 8.14 0 003.17-6.59zm-1.2-3.95c-.34 1.72.74 2.21.63 3a.92.92 0 01-1 .78 1.08 1.08 0 01-.95-.92 3.48 3.48 0 011.32-2.86z","opacity":".15"}})])])])
          )
        }
      }
    